// extracted by mini-css-extract-plugin
export default {"cls1":"SearchBar-cls1_X_f","cls2":"SearchBar-cls2__nJ SearchBar-cls1_X_f"};